import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getNoShipments,
    getNoShipmentsWithTrackingEvents,
    getNoDelivered,
    getNoUndelivered,
    getNoExceptions,
    getTrackingStatus,
    getTrackingStatusByTimeframe,
    getTrackingStatusSummary,
} from '../../helpers';
import {
    trackingStatusAnalyticsApiResponseSuccess,
    trackingStatusAnalyticsApiResponseError,
} from './actions';
import { TrackingStatusAnalyticsActionTypes } from './constants';

export function* getNoShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getNoShipments, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS, error));
    }
}

export function* getNoShipmentsWithTrackingEventsSaga({ payload: { query } }) {
    try {
        const response = yield call(getNoShipmentsWithTrackingEvents, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS, error));
    }
}

export function* getNoDeliveredSaga({ payload: { query } }) {
    try {
        const response = yield call(getNoDelivered, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED, error));
    }
}

export function* getNoUndeliveredSaga({ payload: { query } }) {
    try {
        const response = yield call(getNoUndelivered, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED, error));
    }
}

export function* getNoExceptionsSaga({ payload: { query } }) {
    try {
        const response = yield call(getNoExceptions, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS, error));
    }
}

export function* getTrackingStatusSaga({ payload: { query } }) {
    try {
        const response = yield call(getTrackingStatus, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS, error));
    }
}

export function* getTrackingStatusByTimeframeSaga({ payload: { query } }) {
    try {
        const response = yield call(getTrackingStatusByTimeframe, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME, error));
    }
}

export function* getTrackingStatusSummarySaga({ payload: { query } }) {
    try {
        const response = yield call(getTrackingStatusSummary, query);
        yield put(trackingStatusAnalyticsApiResponseSuccess(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY, response.data));
    } catch (error) {
        yield put(trackingStatusAnalyticsApiResponseError(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY, error));
    }
}

export function* watchGetNoShipmentsSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS, getNoShipmentsSaga);
}

export function* watchGetNoShipmentsWithTrackingEventsSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_NO_SHIPMENTS_WITH_TRACKING_EVENTS, getNoShipmentsWithTrackingEventsSaga);
}

export function* watchGetNoDeliveredSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_NO_DELIVERED, getNoDeliveredSaga);
}

export function* watchGetNoUndeliveredSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_NO_UNDELIVERED, getNoUndeliveredSaga);
}

export function* watchGetNoExceptionsSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_NO_EXCEPTIONS, getNoExceptionsSaga);
}

export function* watchGetTrackingStatusSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS, getTrackingStatusSaga);
}

export function* watchGetTrackingStatusByTimeframeSaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_BY_TIMEFRAME, getTrackingStatusByTimeframeSaga);
}

export function* watchGetTrackingStatusSummarySaga(): any {
    yield takeLatest(TrackingStatusAnalyticsActionTypes.GET_TRACKING_STATUS_SUMMARY, getTrackingStatusSummarySaga);
}

function* trackingStatusAnalyticsSaga() {
    yield all([
        fork(watchGetNoShipmentsSaga),
        fork(watchGetNoShipmentsWithTrackingEventsSaga),
        fork(watchGetNoDeliveredSaga),
        fork(watchGetNoUndeliveredSaga),
        fork(watchGetNoExceptionsSaga),
        fork(watchGetTrackingStatusSaga),
        fork(watchGetTrackingStatusByTimeframeSaga),
        fork(watchGetTrackingStatusSummarySaga),
    ]);
}

export default trackingStatusAnalyticsSaga;
